import { makeSelectors } from '@utils/css';

const tooltip = "dibttcmgcd";
const arrow = "diba1il7ggb";
const label = "dibla28vq3";
const shortcut = "dibsedmzpd";
const selectors = makeSelectors({
  label,
  arrow,
  shortcut
});

export { arrow, label, selectors, shortcut, tooltip };
import "./tooltip.styles.linaria.module.css";
//# sourceMappingURL=tooltip.styles.js.map
